import { render, staticRenderFns } from "./packPrescription.vue?vue&type=template&id=38da3714&scoped=true"
import script from "./packPrescription.vue?vue&type=script&lang=js"
export * from "./packPrescription.vue?vue&type=script&lang=js"
import style0 from "./packPrescription.vue?vue&type=style&index=0&id=38da3714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38da3714",
  null
  
)

export default component.exports